import { render, staticRenderFns } from "./serviceResource.vue?vue&type=template&id=60329342&scoped=true"
import script from "./serviceResource.vue?vue&type=script&lang=js"
export * from "./serviceResource.vue?vue&type=script&lang=js"
import style0 from "./serviceResource.vue?vue&type=style&index=0&id=60329342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60329342",
  null
  
)

export default component.exports